import { render } from "./Newrelease.vue?vue&type=template&id=7bd5d1e5&scoped=true"
import script from "./Newrelease.vue?vue&type=script&lang=js"
export * from "./Newrelease.vue?vue&type=script&lang=js"

import "./Newrelease.vue?vue&type=style&index=0&id=7bd5d1e5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7bd5d1e5"

export default script